module.exports = __webpack_public_path__ + "static/img/2.a3bce7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/eng/2.png
// module id = rU8g
// module chunks = 0